import type { AllRouteEndpoints } from "../routeTypes";

export const engagementAppGroupIdSuppressionRulesId = "/engagement/:app_group_id/suppression_rules/:id";

/**
 * Editing a rule changes how it appears in the list (status, last edited), so the list route is
 * invalidated alongside the rule itself.
 */
export const engagementAppGroupIdSuppressionRulesIdCacheKeys: AllRouteEndpoints[] = [
  "/engagement/:app_group_id/suppression_rules/:id",
  "/engagement/:app_group_id/suppression_rules",
];
